import { render } from "./feesregistry.vue?vue&type=template&id=8dba9572"
import script from "./feesregistry.vue?vue&type=script&lang=js"
export * from "./feesregistry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__